/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteTimelineConstraintDtoModel, RouteTimelineConstraintDtoModelType } from "./RouteTimelineConstraintDtoModel"
import { RouteTimelineConstraintDtoModelSelector } from "./RouteTimelineConstraintDtoModel.base"
import { RouteTimelineEtaDtoModel, RouteTimelineEtaDtoModelType } from "./RouteTimelineEtaDtoModel"
import { RouteTimelineEtaDtoModelSelector } from "./RouteTimelineEtaDtoModel.base"
import { RouteTimelineEventSummaryDtoModel, RouteTimelineEventSummaryDtoModelType } from "./RouteTimelineEventSummaryDtoModel"
import { RouteTimelineEventSummaryDtoModelSelector } from "./RouteTimelineEventSummaryDtoModel.base"
import { RouteTimelineLogDtoModel, RouteTimelineLogDtoModelType } from "./RouteTimelineLogDtoModel"
import { RouteTimelineLogDtoModelSelector } from "./RouteTimelineLogDtoModel.base"
import { RouteTimelineViolationDtoModel, RouteTimelineViolationDtoModelType } from "./RouteTimelineViolationDtoModel"
import { RouteTimelineViolationDtoModelSelector } from "./RouteTimelineViolationDtoModel.base"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  visit: VisitDtoModelType;
  orders: IObservableArray<VisitDtoModelType>;
  violations: IObservableArray<RouteTimelineViolationDtoModelType>;
  eta: RouteTimelineEtaDtoModelType;
  logs: IObservableArray<RouteTimelineLogDtoModelType>;
  constraints: RouteTimelineConstraintDtoModelType;
}

/**
 * RouteTimelineDtoBase
 * auto generated base class for the model RouteTimelineDtoModel.
 */
export const RouteTimelineDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteTimelineDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineDto"), "RouteTimelineDto"),
    id: types.identifier,
    routeSolutionId: types.union(types.undefined, types.integer),
    visitId: types.union(types.undefined, types.null, types.integer),
    visit: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => VisitDtoModel))),
    orders: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => VisitDtoModel)))),
    visitTimeWindowId: types.union(types.undefined, types.null, types.integer),
    eventType: types.union(types.undefined, types.string),
    startTime: types.union(types.undefined, types.null, types.string),
    endTime: types.union(types.undefined, types.null, types.string),
    arrivalTime: types.union(types.undefined, types.null, types.string),
    departureTime: types.union(types.undefined, types.null, types.string),
    sequence: types.union(types.undefined, types.integer),
    stopSequence: types.union(types.undefined, types.null, types.integer),
    eventUuid: types.union(types.undefined, types.string),
    orderUuid: types.union(types.undefined, types.null, types.string),
    reattemptEventUuid: types.union(types.undefined, types.null, types.string),
    distance: types.union(types.undefined, types.null, types.integer),
    violations: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => RouteTimelineViolationDtoModel)))),
    eta: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => RouteTimelineEtaDtoModel))),
    logs: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => RouteTimelineLogDtoModel)))),
    isArrived: types.union(types.undefined, types.null, types.boolean),
    isDeparted: types.union(types.undefined, types.null, types.boolean),
    constraints: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => RouteTimelineConstraintDtoModel))),
    eventSummary: types.union(types.undefined, types.null, types.late((): any => RouteTimelineEventSummaryDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteTimelineDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeSolutionId() { return this.__attr(`routeSolutionId`) }
  get visitId() { return this.__attr(`visitId`) }
  get visitTimeWindowId() { return this.__attr(`visitTimeWindowId`) }
  get eventType() { return this.__attr(`eventType`) }
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
  get arrivalTime() { return this.__attr(`arrivalTime`) }
  get departureTime() { return this.__attr(`departureTime`) }
  get sequence() { return this.__attr(`sequence`) }
  get stopSequence() { return this.__attr(`stopSequence`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
  get orderUuid() { return this.__attr(`orderUuid`) }
  get reattemptEventUuid() { return this.__attr(`reattemptEventUuid`) }
  get distance() { return this.__attr(`distance`) }
  get isArrived() { return this.__attr(`isArrived`) }
  get isDeparted() { return this.__attr(`isDeparted`) }
  visit(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`visit`, VisitDtoModelSelector, builder) }
  orders(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`orders`, VisitDtoModelSelector, builder) }
  violations(builder: string | RouteTimelineViolationDtoModelSelector | ((selector: RouteTimelineViolationDtoModelSelector) => RouteTimelineViolationDtoModelSelector) | undefined) { return this.__child(`violations`, RouteTimelineViolationDtoModelSelector, builder) }
  eta(builder: string | RouteTimelineEtaDtoModelSelector | ((selector: RouteTimelineEtaDtoModelSelector) => RouteTimelineEtaDtoModelSelector) | undefined) { return this.__child(`eta`, RouteTimelineEtaDtoModelSelector, builder) }
  logs(builder: string | RouteTimelineLogDtoModelSelector | ((selector: RouteTimelineLogDtoModelSelector) => RouteTimelineLogDtoModelSelector) | undefined) { return this.__child(`logs`, RouteTimelineLogDtoModelSelector, builder) }
  constraints(builder: string | RouteTimelineConstraintDtoModelSelector | ((selector: RouteTimelineConstraintDtoModelSelector) => RouteTimelineConstraintDtoModelSelector) | undefined) { return this.__child(`constraints`, RouteTimelineConstraintDtoModelSelector, builder) }
  eventSummary(builder: string | RouteTimelineEventSummaryDtoModelSelector | ((selector: RouteTimelineEventSummaryDtoModelSelector) => RouteTimelineEventSummaryDtoModelSelector) | undefined) { return this.__child(`eventSummary`, RouteTimelineEventSummaryDtoModelSelector, builder) }
}
export function selectFromRouteTimelineDto() {
  return new RouteTimelineDtoModelSelector()
}

export const routeTimelineDtoModelPrimitives = selectFromRouteTimelineDto().routeSolutionId.visitId.visitTimeWindowId.eventType.startTime.endTime.arrivalTime.departureTime.sequence.stopSequence.eventUuid.orderUuid.reattemptEventUuid.distance.isArrived.isDeparted
